import { StatusFilterEnum, SupportState } from '.';

export const initialState: SupportState = {
  List: [],
  loading: false,
  buttonLoading: false,
  search: '',
  pageNo: 1,
  pageSize: 10,
  totalRow: 0,
  orderBy: '',
  orderDir: '',
  status: StatusFilterEnum.ALL
};
